import { SapCollateralChangeSnapshot } from '@/components/Approval/@components/SapCollateralChange';
import { parseSapCollateralContent } from '@/utils/approval/sapCollateralChange';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 154·155 SAP 담보 신규·변경 — 저장 content 그대로(레거시 문서 포함). SAP 재조회 안 함 */
const SapCollateralChangeSlot = ({ data }: ContentExtraProps) => {
  const content = parseSapCollateralContent(data.attributes);
  if (!content) return null;
  return (
    <ContentSlotRoot>
      <SapCollateralChangeSnapshot content={content} />
    </ContentSlotRoot>
  );
};

export default SapCollateralChangeSlot;
